export class SumupGroup {
  id: number
  school_id: number
  exec_date: string
  name: string

  constructor(sumupGroup: any){
    this.id = sumupGroup.id;
    this.school_id = sumupGroup.school_id;
    this.exec_date = sumupGroup.exec_date;
    this.name = sumupGroup.name;
  }
}

export class SumupGroupDetail {
  id: number
  sumup_group_id: number
  sheet_group_key: number

  constructor(sumupGroupDetail: any){
    this.id = sumupGroupDetail.id;
    this.sumup_group_id = sumupGroupDetail.sumup_group_id;
    this.sheet_group_key = sumupGroupDetail.sheet_group_key;
  }
}

export class Sheet {
  sheet_group_key: number
  exec_date: string
  name: string
  curriculum_id: number
  subject_name: string
  isSelected: boolean

  constructor(sheet: any, sumupGroupDetails: SumupGroupDetail[]){
    this.sheet_group_key = sheet.sheet_group_key;
    this.exec_date = sheet.exec_date;
    this.name = sheet.name;
    this.curriculum_id = sheet.curriculum_id;
    this.subject_name = sheet.subject_name;
    this.isSelected = sumupGroupDetails.filter(x => x.sheet_group_key == this.sheet_group_key).length > 0;
  }
}